<template>
  <div class="speedQuery" v-loading.fullscreen.lock="loading">
    <div class="speedQuery_Breadcrumb">
      <Breadcrumb separator=">">
        <span style="padding:0 10px 0 0">当前位置:&nbsp;&nbsp;</span>
        <BreadcrumbItem to="/home">首页</BreadcrumbItem>
        <BreadcrumbItem>进度查询</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="speedQuery_new">
      <div class="speedQuery_new_item">
        <div class="speedQuery_new_item_header">信息简介</div>
        <div class="speedQuery_new_item_cont">
          <div class="txt">
            <strong>姓名:</strong>
            {{userNmae}}
          </div>
          <div class="txt" v-if="identity_type <3">
            <strong>执业机构:</strong>
            {{zyjg}}
          </div>
          <div class="txt" v-else>
            <strong>单位名称:</strong>
            {{dwmc}}
          </div>
          <div class="txt">
            <strong>考生类型:</strong>
            {{kslx}}
          </div>
          <div class="txt">
            <Button ghost @click="details">查看详情</Button>&nbsp;&nbsp;
            <Button ghost @click="updataNew" v-if="submitState==0">修改信息</Button>&nbsp;&nbsp;
            <Button ghost @click="withdraw" v-if="submitState==1 && (cur_audit_status==0 || cur_audit_status == 3)">撤回修改</Button>&nbsp;&nbsp;
            <Button ghost @click="uploadCertificate" v-if="sjshStateCode==1 && isallow === 1">打印准考证</Button>
          </div>
        </div>
      </div>
      <div class="speedQuery_new_line"></div>
      <div class="speedQuery_new_item" style="margin-top:20px">
        <div class="speedQuery_new_item_header">进度查询</div>
        <div class="speedQuery_new_item_cont">
          <div class="speedQuery_progress">
            <!--报名阶段-->
            <div class="speedQuery_progress_line" style="width: 100px;">
              <div class="speedQuery_progress_line_cont statrt"></div>
              <div class="spot select"></div>
              <span class="title select">提交报名</span>
              <div class="speedQuery_state">
                <span class="txts">{{submitName}}&nbsp;</span>
                <span class="txts">{{submitTime}}</span>
              </div>
            </div>
            <!--县级初审-->
            <div class="speedQuery_progress_line" style="width: 300px;">
              <div :class="['spot',xjshState?'select':'noSelect']"></div>
              <div class="speedQuery_progress_line_cont" :class="[xjshState?'isSelect':'noSelect']"></div>
              <span class="title" :class="{select:xjshState}">县级初审</span>
              <div class="speedQuery_state" v-if="xjshState">
                <span
                  class="txts"
                  :class="[xjshStateCode==1?'success':'Fail']"
                >{{xjshStateName}}&nbsp;</span>
                <span class="txts">{{xjshStateTime}}</span>
                <span class="speedQuery_state_btn" v-if="xjshStateBtn" @click="xjshHint">查看详情</span>
              </div>
            </div>
            <!--市级复审-->
            <div class="speedQuery_progress_line" style="width: 300px;">
              <div class="spot" :class="['spot',sjshState?'select':'noSelect']"></div>
              <div class="speedQuery_progress_line_cont" :class="[sjshState?'isSelect':'noSelect']"></div>
              <span class="title" :class="{select:sjshState}">市级复审</span>
              <div class="speedQuery_state" v-if="sjshState">
                <span
                  class="txts"
                  :class="[sjshStateCode==1?'success':'Fail']"
                >{{sjshStateName}}&nbsp;</span>
                <span class="txts">{{sjshStateTime}}</span>
                <span class="speedQuery_state_btn" v-if="sjshStateBtn" @click="sjshHint">查看详情</span>
              </div>
            </div>
            <!--省级终审-->
            <div class="speedQuery_progress_line" style="width: 300px;">
              <div class="spot" :class="['spot',sjshState1?'select':'noSelect']"></div>
              <div
                class="speedQuery_progress_line_cont"
                :class="[sjshState1?'isSelect':'noSelect']"
              ></div>
              <span class="title" :class="{select:sjshState1}">省级终审</span>
              <div class="speedQuery_state" v-if="sjshState1">
                <span
                  class="txts"
                  :class="[sjshState1Code==1?'success':'Fail']"
                >{{sjshStateName1}}&nbsp;</span>
                <span class="txts">{{sjshStateTime1}}</span>
                <span class="speedQuery_state_btn" v-if="sjshStateBtn1" @click="sjsh1Hint">查看详情</span>
              </div>
            </div>
            <div class="speedQuery_progress_line" style="width: 100px;">
              <div class="speedQuery_progress_line_cont endIsColor"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.speedQuery {
  width: 1200px;
  margin: 0 auto;
  .speedQuery_Breadcrumb {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;
  }
  .speedQuery_new {
    margin-top: 30px;
    background-image: linear-gradient(0deg, #ffffff 50%, #ffffff 100%);
    border-radius: 3px;
    padding: 10px;
    box-sizing: border-box;
    .speedQuery_new_item_header {
      height: 18px;
      line-height: 18px;
      text-indent: 10px;
      border-left: 2px solid #00b49b;
      font-weight: bold;
    }
    .speedQuery_new_item_cont {
      padding: 15px 0;
      display: flex;
      .txt {
        flex: 1;
        height: 35px;
        line-height: 35px;
        padding: 0 10px;
        box-sizing: border-box;
        font-size: 13px;
        strong {
          font-size: 13px;
          padding-right: 5px;
        }
        .ivu-btn {
          border-color: #00b49b;
          color: #00b49b;
        }
      }
      .speedQuery_progress {
        height: 174px;
        display: flex;
        margin: 0 auto;
        .speedQuery_progress_line {
          height: 70px;
          position: relative;
          .speedQuery_progress_line_cont {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1.5px;
            border-radius: 1px;
          }
          .speedQuery_progress_line_cont.statrt {
            background-image: linear-gradient(
              to right,
              rgba(0, 180, 155, 0),
              #00b49b
            );
          }
          .speedQuery_progress_line_cont.isSelect {
            background-color: #00b49b;
          }
          .speedQuery_progress_line_cont.endIsColor {
            background-image: linear-gradient(
              to right,
              #dddddd,
              rgba(221, 221, 221, 0)
            );
          }
          .speedQuery_progress_line_cont.noSelect {
            background-color: #dddddd;
          }

          .spot {
            position: absolute;
            right: 0;
            bottom: -5px;
            width: 13px;
            height: 13px;
            border-radius: 50%;
            z-index: 1;
          }
          .spot.select {
            background: #00b49b;
          }
          .spot.NowSelect {
            background: #00b49b;
            box-shadow: 0 0 5px 2px rgba(0, 180, 155, 0.5);
          }
          .spot.noSelect {
            border: 1px solid #dddddd;
            background: #fff;
          }
          .title {
            position: absolute;
            right: -20px;
            bottom: 15px;
            font-size: 13px;
            color: #bbbbbb;
            z-index: 2;
          }
          .title.select {
            color: #00b49b;
          }
          .speedQuery_state {
            position: absolute;
            right: -55px;
            bottom: 40px;
            color: #bbbbbb;
            z-index: 3;
            .txts {
              float: left;
              padding-right: 7px;
              font-size: 12px;
            }
            .txts.success {
              color: #00b49b;
            }
            .txts.Fail {
              color: #ff0000;
            }
            .speedQuery_state_btn {
              float: left;
              border-color: #00b49b;
              color: #00b49b;
              width: 60px;
              height: 20px;
              line-height: 20px;
              font-size: 10px;
              text-align: center;
              border-radius: 3px;
              border: 1px solid #00b49b;
              cursor: pointer;
            }
          }
        }
      }
    }
    .speedQuery_new_line {
      height: 1px;
      background-color: #eeeeee;
      box-shadow: 1px 1px 0px 0px #ffffff;
    }
  }
}
</style>
<script>
import util from "@/libs/util";
import { UserNew, DeclareListState, Withdraw, sysprojectcfgs } from "@/api/declare/index";
export default {
  data() {
    return {
      loading: false,
      id: '',
      identity_type:null,
      userNmae: "",
      zyjg: "",
      dwmc: "",
      kslx: "",
      cur_audit_status: 0,
      project_code: "",
      isallow: null,
      //撤回id
      withdrawState: false,
      withdrawId: "",
      //进度
      submitState: 1,
      cur_audit_org_lv: 0,
      submitName: "",
      submitTime: "",
      //县级
      xjshState: false,
      xjshStateCode: 0,
      xjshStateName: "",
      xjshStateTime: "",
      xjshStateBtn: false,
      xjshStateNotes: "",
      //市级
      sjshState: false,
      sjshStateCode: 0,
      sjshStateName: "",
      sjshStateTime: "",
      sjshStateBtn: false,
      sjshStateNotes: "",
      //省级
      sjshState1: false,
      sjshState1Code: 0,
      sjshStateName1: "",
      sjshStateTime1: "",
      sjshStateBtn1: false,
      sjshState1Notes: ""
    };
  },
  created() {
    this.getUserNew();
    this.getsysprojectcfgs();
  },
  methods: {
    //获取考生信息简介
    getUserNew() {
      this.loading = true;
      let id = util.storage.getUserInfo().obj_id;
      UserNew(id).then(res => {
        this.userNmae = res.name;
        this.zyjg = res.practice_org;
        this.dwmc = res.company_name;
        this.identity_type = res.identity_type;
        switch(res.identity_type){
          case 1:
          this.kslx = "师承方式学习中医";
          break;
          case 2:
          this.kslx = "多年中医医术实践";
          break;
          case 3:
          this.kslx = "师承出师";
          break;
          case 4:
          this.kslx = "确有专长";
          break;
        }
        this.getSpeed();
      })
      .catch(() => {
        this.loading = false;
      });
    },
    //查看详细
    details() {
      let prjCode = (this.project_code).substring(0,(this.project_code).length-4);
      if(prjCode === "sczyps"){   /// 确有专长
        this.$router.push({
          name: "speedDetails",
          params: {
            code: this.$route.params.code
          }
        });
      }else if(prjCode === "sczykh"){ // 传统医学
        this.$router.push({
          name: "sczykhDetail",
          params: {
            code: this.$route.params.code
          }
        });
      }
      
    },
    //获取进度查询接口
    getSpeed() {
      this.loading = true;
      let params = {
        user_id: util.storage.getUserInfo().obj_id,
        project_code: this.$route.params.code
      };
      DeclareListState(params)
        .then(res => {
          this.id = res[0].id
          this.project_code = res[0].project_code;
          this.cur_audit_status = res[0].cur_audit_status;
          this.withdrawId = res[0].id;
          this.submitState = res[0].submit_status;
          this.cur_audit_org_lv = res[0].cur_audit_org_lv;
          this.submitName = res[0].modify_username;
          this.submitTime = util.tool.dateFormat(
            "yyyy-MM-dd",
            new Date(res[0].submit_date)
          );
          //县级
          this.xjshStateCode = res[0].audit_status_val3;
          this.xjshStateNotes = res[0].audit_notes3;
          if (res[0].audit_status_val3 == 0) {
            this.xjshState = false;
          } else {
            this.xjshState = true;
            this.xjshStateName = res[0].audit_status_txt3;
            this.xjshStateTime = util.tool.dateFormat(
              "yyyy-MM-dd",
              new Date(res[0].audit_date3)
            );
            if (res[0].audit_status_val3 > 1) {
              this.xjshStateBtn = true;
            }
          }
          //市级
          this.sjshStateCode = res[0].audit_status_val2;
          this.sjshStateNotes = res[0].audit_notes2;
          if (res[0].audit_status_val2 == 0) {
            this.sjshState = false;
          } else {
            this.sjshState = true;
            this.sjshStateName = res[0].audit_status_txt2;
            this.sjshStateTime = util.tool.dateFormat(
              "yyyy-MM-dd",
              new Date(res[0].audit_date2)
            );
            if (res[0].audit_status_val2 > 1) {
              this.sjshStateBtn = true;
            }
          }
          //省级
          this.sjshState1Code = res[0].audit_status_val1;
          this.sjshState1Notes = res[0].audit_notes1;
          if (res[0].audit_status_val1 == 0) {
            this.sjshState1 = false;
          } else {
            this.sjshState1 = true;
            this.sjshStateName1 = res[0].audit_status_txt1;
            this.sjshStateTime1 = util.tool.dateFormat(
              "yyyy-MM-dd",
              new Date(res[0].audit_date1)
            );
            if (res[0].audit_status_val1 > 1) {
              this.sjshStateBtn1 = true;
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 获取项目是否打印准考证
    getsysprojectcfgs() {
      let projectCode = this.$route.params.code;
      sysprojectcfgs(projectCode).then(res => {
        this.isallow = res.isallow;
      }).catch(() => {
        this.loading = false;
      });
    },
    //撤回
    withdraw() {
      this.$Modal.confirm({
        title: "提示信息",
        content: "是否撤销提交的信息?",
        onOk: () => {
          this.loading = true;
          Withdraw(this.withdrawId)
            .then(() => {
              this.loading = false;
              this.$Message.success("撤销成功!");
              this.getUserNew();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    //修改信息
    updataNew() {
      let prjCode = (this.project_code).substring(0,(this.project_code).length-4);
      if(prjCode === "sczyps"){
        this.$router.push({
          name: "declare",
          params: {
            id: this.project_code
          }
        });
      }else if(prjCode === "sczykh"){
        this.$router.push({
          name: "declares",
          params: {
            id: this.project_code
          }
        });
      }
    },
    //县级审核失败备注
    xjshHint() {
      this.$Modal.error({
        title: "提示内容",
        content: this.xjshStateNotes
      });
    },
    //市级审核失败备注
    sjshHint() {
      this.$Modal.error({
        title: "提示内容",
        content: this.sjshStateNotes
      });
    },
    //省级审核失败备注
    sjsh1Hint() {
      this.$Modal.error({
        title: "提示内容",
        content: this.sjshState1Notes
      });
    },
    // 下载证书
    uploadCertificate() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认打印准考证?</p>',
        onOk: () => {
          // 模板下载文件地址
          let downloadUrl = ''
          let prjCode = (this.project_code).substring(0,(this.project_code).length-4);
          if(prjCode === "sczykh") {
            downloadUrl = process.env.VUE_APP_BASE_URL+'/webapi/api/auditmain/print_exam_ticket?auditMainId='+this.id+'&access_token='+util.cookies.get('token');
          }
          else {
            let idcardNo = util.storage.getUserInfo().idcard_no;
            downloadUrl = process.env.VUE_APP_BASE_URL+'/webapi/api/auditmain/export_exam_ticket_zyys_temporary?idcardNo='+ idcardNo +'&access_token='+util.cookies.get('token');
          }
         
          var a = document.createElement("a");
          a.setAttribute("href", downloadUrl);
          a.setAttribute("target", "_blank");
          a.setAttribute("id", "startTelMedicine");
          // 防止反复添加
          if (document.getElementById("startTelMedicine")) {
            document.body.removeChild(
              document.getElementById("startTelMedicine")
            );
          }
          document.body.appendChild(a);
          a.click();
        }
      });
    }
  }
};
</script>